import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MainAuthGuard implements CanActivate {
    constructor(private http: HttpClient, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.http.get<string>('/api/site/authenticated', { responseType: 'text' as 'json' }).pipe(
            map(result => {
                const trimmedResult = result.replace(/"/g, '').trim(); // Remove quotes and trim whitespace
                console.log(trimmedResult);
                if (trimmedResult === 'LoggedIn') {
                    return true;
                } else {
                    // Redirect to login with return URL if applicable
                    return this.router.createUrlTree(['/Login'], {
                        queryParams: { returnUrl: state.url }
                    });
                }
            }),
            catchError(error => {
                console.error("An error occurred during authentication:", error);
                // Redirect to login page
                return of(this.router.createUrlTree(['/Login'], {
                    queryParams: { returnUrl: state.url }
                }));
            })
        );
    }
}

@Injectable({
    providedIn: 'root'
})
export class HalfAuthGuard implements CanActivate {
    constructor(private http: HttpClient, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        console.log('HalfAuthGuard called');

        return this.http.get<string>('/api/site/authenticated', { responseType: 'text' as 'json' }).pipe(
            map(result => {
                // Always return true or false based on your logic
                return true; // Adjust as needed
            }),
            catchError(error => {
                console.error("An error occurred during authentication:", error);
                // Redirect to login page
                return of(this.router.createUrlTree(['/Login']));
            })
        );
    }
}
